export const defualtMeta = [
	{
		vmid: 'description',
		name: 'description',
		content: '서비스 신청',
	},
];
